import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "../../ui/button";

const STORAGE_KEY = "edunova_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const consent = window.localStorage.getItem(STORAGE_KEY);
      if (!consent) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const handleChoice = (value) => {
    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch {
        // ignore storage errors (e.g. private browsing)
      }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de uso de cookies"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6"
    >
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-4 rounded-2xl border border-[#e6d5ba] bg-white p-5 shadow-2xl sm:flex-row sm:items-center">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#4a321c]/10 text-[#4a321c]">
          <Cookie className="h-5 w-5" />
        </div>

        <p className="flex-1 text-sm leading-relaxed text-gray-600">
          Usamos cookies propias y de terceros para mejorar tu experiencia de
          navegación y analizar el uso del sitio. Puedes conocer más detalles
          en nuestra{" "}
          <Link
            to="/privacy-policy"
            className="font-medium text-[#4a321c] underline hover:no-underline"
          >
            Política de Privacidad
          </Link>
          .
        </p>

        <div className="flex w-full shrink-0 gap-2 sm:w-auto">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleChoice("rejected")}
            className="flex-1 border-[#4a321c]/30 text-[#4a321c] hover:bg-[#4a321c]/10 sm:flex-none"
          >
            Rechazar
          </Button>
          <Button
            size="sm"
            onClick={() => handleChoice("accepted")}
            className="flex-1 bg-[#4a321c] text-white hover:bg-[#5b4229] sm:flex-none"
          >
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
}
